
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitokolhapurcab() {



    const cardData =
    {
        keyword: 'Mumbai to Kolhapur Cab',
        heading: 'Skyline Cabs: Mumbai to Kolhapur Cab',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Mumbai to Kolhapur Cab services for a seamless travel experience. Whether you’re traveling for business, visiting the historic temples, or exploring the cultural richness of Kolhapur, our well-maintained vehicles and experienced drivers ensure a smooth and safe journey. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Mumbai to Kolhapur cab with Skyline Cabs today and experience a stress-free ride to one of Maharashtra’s most vibrant cities!',

        top: 'Top Places to Visit in Kolhapur with Skyline Cabs',

"topPlaces": [
    {
        "title": "Mahalakshmi Temple",
        "description": "One of the most revered temples in Maharashtra, the Mahalakshmi Temple is dedicated to Goddess Lakshmi. It is known for its intricate architecture, sacred significance, and the unique idol of the goddess."
    },
    {
        "title": "Panhala Fort",
        "description": "Located 20 km from Kolhapur, Panhala Fort is a historical site offering panoramic views of the surrounding hills. The fort is associated with the Maratha Empire and is known for its impressive architecture and cool climate."
    },
    {
        "title": "New Palace",
        "description": "The New Palace in Kolhapur, built in the 19th century, is an architectural marvel. It now houses a museum showcasing the royal artifacts of the Kolhapur dynasty, including the famous Kolhapuri chappals."
    },
    {
        "title": "Rankala Lake",
        "description": "A popular spot for picnics and evening strolls, Rankala Lake is surrounded by lush greenery. It offers boating opportunities and is a perfect place for relaxation and sunset views."
    },
    {
        "title": "Jyotiba Temple",
        "description": "Situated atop a hill, the Jyotiba Temple is dedicated to Lord Jyotiba, and is a significant pilgrimage site. The temple offers a tranquil atmosphere and provides a commanding view of the surrounding landscape."
    },
    {
        "title": "Shivaji University",
        "description": "Shivaji University, located on the outskirts of Kolhapur, is known for its beautiful campus and historical importance. It is one of the oldest educational institutions in the region."
    },
    {
        "title": "Bhavani Mandap",
        "description": "This historic building was the court of the Maratha kings and is known for its ancient architecture. It is often visited by history enthusiasts interested in learning about Kolhapur's royal past."
    },
    {
        "title": "Kusumavati Lake",
        "description": "A peaceful and scenic lake located in the outskirts of Kolhapur, Kusumavati Lake is ideal for nature walks and is a great spot for birdwatching, especially during the monsoon."
    },
    {
        "title": "Mahalaxmi Race Course",
        "description": "The Mahalaxmi Race Course in Kolhapur is an exciting destination for sports enthusiasts. It hosts horse races and other events, and the place offers an opportunity to enjoy the thrills of racing."
    },
    {
        "title": "Kolhapur Zoo",
        "description": "The Kolhapur Zoo, located in the heart of the city, is home to a variety of animals and birds. It is well-maintained and provides a fun and educational experience for families and children."
    }
],

"services": [
    {
      "name": "Mumbai to Goa Cabs",
      "description": "Skyline Cabs offers comfortable and convenient taxi services from Mumbai to Goa. Our cabs are fully equipped for long journeys, providing a smooth and relaxing ride to the beautiful beaches of Goa."
    },
    {
      "name": "Mumbai to Goa Taxi Service",
      "description": "Choose Skyline Cabs for a reliable taxi service from Mumbai to Goa. We ensure punctuality, comfort, and a stress-free travel experience as you journey towards Goa's serene coastal beauty."
    },
    {
      "name": "Mumbai to Goa Cab Fare",
      "description": "The fare for a taxi ride from Mumbai to Goa depends on the type of vehicle you choose and the distance covered. We offer competitive rates for our cab services, ensuring great value for money."
    },
    {
      "name": "Goa Cab Service from Mumbai",
      "description": "Skyline Cabs provides a premium taxi service for your journey from Mumbai to Goa. Whether you are traveling for business or leisure, our cabs are ready to offer comfort and safety."
    },
    {
      "name": "Mumbai to Goa One Way Cab",
      "description": "Book a one-way cab from Mumbai to Goa with Skyline Cabs. This service ensures you have a hassle-free ride to Goa and is perfect for those looking to travel one way only."
    },
    {
      "name": "Taxi from Mumbai to Goa",
      "description": "Get a taxi from Mumbai to Goa with Skyline Cabs. Our service guarantees a comfortable and safe ride with experienced drivers, ensuring you reach your destination on time."
    },
    {
      "name": "Mumbai Goa Cab Booking",
      "description": "Booking a cab for your journey from Mumbai to Goa is easy with Skyline Cabs. You can book your taxi in advance through our online platform or contact us directly to arrange your travel."
    }
  ],
  "tableData": [
    ["Mumbai to Goa Cabs", "Mumbai to Goa Taxi Service"],
    ["Mumbai to Goa Cab Fare", "Goa Cab Service from Mumbai"],
    ["Mumbai to Goa One Way Cab", "Taxi from Mumbai to Goa"],
    ["Mumbai Goa Cab Booking"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Reliable Mumbai to Kolhapur Cab Service",
      "WhyChoosedescription": "Experience a dependable and smooth Mumbai to Kolhapur cab service. Whether for leisure or work, we ensure a hassle-free travel experience tailored to your needs."
    },
    {
      "WhyChooseheading": "Comfortable and Long-Distance Ready Cabs",
      "WhyChoosedescription": "Our cabs are built for long-distance journeys, offering plush seating, great suspension, and a peaceful ride—perfect for the scenic drive from Mumbai to Kolhapur."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Enjoy competitive and clearly defined rates for your Mumbai to Kolhapur cab journey. No surprises, no hidden fees—just honest pricing."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Drivers",
      "WhyChoosedescription": "Our drivers know the Mumbai to Kolhapur route well and are committed to providing a safe, timely, and pleasant travel experience."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
      "WhyChoosedescription": "All our cabs are regularly sanitized and maintained to ensure maximum hygiene, safety, and comfort throughout your trip."
    },
    {
      "WhyChooseheading": "Flexible Booking Options",
      "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans to suit your schedule for your Mumbai to Kolhapur journey."
    },
    {
      "WhyChooseheading": "24/7 Support and Easy Booking Process",
      "WhyChoosedescription": "Book online or call us anytime. Our 24/7 support team makes the booking process simple and convenient."
    },
    {
      "WhyChooseheading": "Ideal for Family, Business, or Group Travel",
      "WhyChoosedescription": "Whether traveling with loved ones or colleagues, our cabs provide the space, comfort, and reliability you need for your Mumbai to Kolhapur trip."
    }
  ]
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Kolhapur with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai to Kolhapur is simple and convenient. You can book through our website, mobile app, or by calling our customer support. Just enter your pickup location, travel date, and select your preferred vehicle for the journey.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Kolhapur?',
            answer:
                'The distance from Mumbai to Kolhapur is approximately 390 km. The travel time usually ranges from 6 to 8 hours, depending on traffic and road conditions. Our drivers take the best routes to ensure a smooth and timely journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Kolhapur trip?',
            answer:
                'We offer a variety of vehicles for the Mumbai to Kolhapur journey, including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups, we provide Tempo Travellers and luxury coaches.',
        },
        {
            id: 4,
            question: 'Are your cab fares for Mumbai to Kolhapur fixed?',
            answer:
                'Yes, we provide fixed and transparent pricing for your Mumbai to Kolhapur journey. The fare includes vehicle rental, driver charges, fuel, tolls, taxes, and any applicable service fees. You will know the total fare before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai to Kolhapur?',
            answer:
                'Yes, we offer one-way cab options for your convenience. You can choose a round-trip service if you plan to return to Mumbai at a later time.',
        },
        {
            id: 6,
            question: 'What is the best time to travel from Mumbai to Kolhapur?',
            answer:
                'The best time to travel to Kolhapur is during the cooler months from October to March. However, Skyline Cabs operates year-round, and our drivers are experienced in handling different weather conditions.',
        },
        {
            id: 7,
            question: 'Are stopovers allowed during the Mumbai to Kolhapur journey?',
            answer:
                'Yes, we allow short stopovers for refreshments, meals, or sightseeing along the way. Let the driver know if you wish to take a break or explore any specific spots on the route.',
        },
        {
            id: 8,
            question: 'What payment options are available for the Mumbai to Kolhapur cab?',
            answer:
                'We accept various payment methods, including UPI, credit/debit cards, net banking, and cash payments after the trip. All online payments are secure and processed through trusted gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai to Kolhapur cab booking?',
            answer:
                'Yes, you can modify or cancel your booking easily via our website, mobile app, or by contacting customer support. We offer flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai to Kolhapur trip?',
            answer:
                'Skyline Cabs offers a comfortable, safe, and reliable journey to Kolhapur. We provide well-maintained vehicles, experienced drivers, and transparent pricing. Our excellent customer service ensures that your trip is enjoyable and hassle-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Suresh Patil",
            rating: 5,
            review: "Our trip from Mumbai to Kolhapur with Skyline Cabs was superb! The driver was very professional, and the vehicle was in excellent condition. We had a comfortable ride, and the journey was enjoyable. Highly recommended!"
        },
        {
            name: "Miss. Aishwarya Deshmukh",
            rating: 4,
            review: "The trip from Mumbai to Kolhapur was smooth and hassle-free with Skyline Cabs. The car was clean and well-maintained, though we wish there was more legroom in the back seat. Overall, a great experience!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Kolhapur Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-kolhapur-cab.jpg",
  "description": "Book Mumbai to Kolhapur cab with Skyline Cabs for a smooth and comfortable journey to the Mahalaxmi Temple and beyond. Travel in AC sedans, SUVs, or luxury tempo travellers with professional drivers at fixed, affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8667"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-kolhapur-cab"
  }
};



      
      
      

    return (
        <div>
<Helmet>
  <title>Mumbai to Kolhapur Cab | Book AC Taxi to Mahalaxmi Temple | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Kolhapur cab with Skyline Cabs for a smooth and comfortable journey to the Mahalaxmi Temple and beyond. Travel in AC sedans, SUVs, or luxury tempo travellers with professional drivers at fixed, affordable fares." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Kolhapur Cab, Kolhapur Mahalaxmi Temple Taxi, AC Cab Mumbai to Kolhapur, Online Cab Booking Kolhapur, SUV Cab Kolhapur Mumbai, Luxury Cab Kolhapur Ride, One Way Taxi Mumbai Kolhapur, Skyline Cabs Kolhapur Travel" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/85.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitokolhapurcab;